<template>
    <div class="company-details">
        <div class="section-row">
            <div class="section-row-header">
                {{ resources.blockCompanyLabel }}
            </div>
        </div>

        <template v-if="!hasSavedAddress">
            <div class="section-row">
                <div v-for="(row, index) in namesRows" :key="index"
                    :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                    <vue-input v-for="element in row" :key="element.id"
                        :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
                </div>
            </div>
        </template>
    </div>
</template>
<script src="./company-details.js"/>
